module.exports = __webpack_public_path__ + "static/media/omdb-movies.175d7e0a.png";